import React, { useEffect, useState } from 'react'
import { Grid, Box, Tabs, Tab, } from "@mui/material";
import OperatorTable from './OperatorTable';
import { CustomTabPanel, a11yProps } from '../Tab/CustomTabPanel';
import AircraftsAvailability from './AircraftsAvailability';
import AssignedAircrafts from './AssignedAircrafts';
import { useLocation, useNavigate } from 'react-router-dom';

const OperatorManagement: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [value, setValue] = React.useState(0);
 const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const index = searchParams.get('index');
  const indexNumber = parseInt(index + "", 10);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    console.log(event)
    setValue(newValue);
    navigate(`/operator-management?index=${newValue}`)
  };

  useEffect(()=>{
    if(indexNumber){
      setValue(indexNumber)
    }else{
      setValue(0)
    }
  },[indexNumber])

  return (
    <>
      <Grid container spacing={2} className="operator-container">
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={12}  className="operator-heading">
            </Grid>
          </Grid>
        </Grid>
      

        <Grid item xs={12} className="tabs-container">
          <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                <Tab label="List of Operators" {...a11yProps(0)} />
                <Tab label="List of Aircrafts Availability" {...a11yProps(1)} />
                <Tab label="List of Assigned Aircrafts" {...a11yProps(2)} />
                {/* <Tab label="Request of Operators" {...a11yProps(2)} /> */}
              </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
              <OperatorTable  />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <AircraftsAvailability />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
              <AssignedAircrafts />
            </CustomTabPanel>
          </Box>




        </Grid>
      </Grid>
    </>
  )
}

export default OperatorManagement;